var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 46,
    viewBox: "0 0 57 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 45.94V10.863C3.49 9.56 8.1 8.769 13.154 8.769c5.053 0 9.663.792 13.154 2.094 3.49-1.302 8.1-2.094 13.154-2.094 5.053 0 9.663.792 13.153 2.094V45.94c-3.49-1.302-8.1-2.094-13.154-2.094-5.053 0-9.663.792-13.153 2.094-3.491-1.302-8.1-2.094-13.154-2.094S3.49 44.638 0 45.94z",
    fill: "#BBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.692 2.093V37.17c3.491-1.302 8.1-2.093 13.154-2.093S53.51 35.868 57 37.17V2.093C53.51.792 48.9 0 43.846 0c-5.053 0-9.663.792-13.154 2.093z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.385 2.093V37.17c3.49-1.302 8.1-2.093 13.153-2.093 5.054 0 9.664.791 13.154 2.093V2.093C27.202.792 22.592 0 17.538 0 12.485 0 7.875.792 4.385 2.093z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.8fe51907498032e41cd108ec9d9e3582.svg";
export { ForwardRef as ReactComponent };